import React,{useState} from "react";
import './services.css'

const Services = () => {
  const [toggleState, setToggleState ] = useState(0)
  const toggleTab = (index) => {
    setToggleState(index) 
  }
  
  return (
    <section className="services section" id="projects">
      <h2 className="section__title">Projects & Hobbies</h2>
      {/* <span className="section__subtitle">My creations and passions</span> */}
      <span className="section__subtitle">My professional and personal exploration</span>
      <div className="services__container container grid">


        {/* security */}
        <div className="services__content">
          <div>
            {/* <i className="uil uil-web-grid services__icon"></i> */}
            {/* <i class="bi bi-globe-central-south-asia services__icon"></i> */}
            <i class="bi bi-map services__icon"></i>
            <h3 className="services__title">
            SIEM Integration<br />and Visualization
            </h3>
            <span>#security</span>
          </div>
          <span className="services__button" onClick={() => toggleTab(1)}>
            View More
            <i className="uil uil-arrow-right services__button-icon"></i>
          </span>
          
          <div
            className={
              toggleState === 1
                ? "services__modal active-modal"
                : "services__modal"
            }
          >
            <div className="services__modal-content">
              <i
                className="uil uil-times services__modal-close"
                onClick={() => toggleTab(0)}
              ></i>
              <h3 className="services__modal-title">Security Incident Visualization with Azure Sentinel</h3>
              <p className="services__modal-description">
              Designed and implemented a comprehensive security monitoring solution in Azure Sentinel to enhance threat detection, visualization, and analysis.
              </p>

              <ul className="services__modal-services grid">
                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                  Automated metadata extraction from Windows Event Viewer using custom PowerShell scripts, forwarding data to a third-party API for geolocation enrichment.
                  </p>
                </li>

                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">Configured a dynamic Azure Sentinel workbook to display real-time global cyberattack patterns, including RDP brute-force attack trends.</p>
                </li>

                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                  Correlated geolocation data with attack magnitudes to provide actionable insights for incident response and threat intelligence.
                  </p>
                </li>

                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                  Enabled seamless integration of enriched event data, improving situational awareness and prioritization of threats.
                  </p>
                </li>

                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                    Design and mockups of products for companies.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Library Management System */}
        <div className="services__content">
          <div>
            {/* <i className="uil uil-arrow services__icon"></i> */}
            <i class="bi bi-journal-check services__icon"></i>
            <h3 className="services__title">
              Library <br/> Management System
            </h3>
          <span>#java</span>
          </div>
          <span className="services__button" onClick={() => toggleTab(2)}>
            View More
            <i className="uil uil-arrow-right services__button-icon"></i>
          </span>
          
          <div
            className={
              toggleState === 2
                ? "services__modal active-modal"
                : "services__modal"
            }
          >
            <div className="services__modal-content">
              <i
                className="uil uil-times services__modal-close"
                onClick={() => toggleTab(0)}
              ></i>
              <h3 className="services__modal-title">Library Management System</h3>
              <p className="services__modal-description">
                  Developed a robust Library Management System in Java to handle book rentals, reader management, and statistical reporting.
              </p>

              <ul className="services__modal-services grid">
                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                  Utilized OOP principles and applied extensive JUnit tests for code validation and reliability.
                  </p>
                </li>

                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                  Managed book and reader archives with unique IDs, enabling easy tracking and retrieval.
                    </p>
                </li>

                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                  Implemented rental management features, allowing rental initiation, closure, and conflict resolution.
                  </p>
                </li>

                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                  Developed archive management to track ongoing rentals and remove unrented books.
                  </p>
                </li>

                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                  Integrated statistical functions to track active readers and generate rental stats per title.
                  </p>
                </li>

                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                  Created a donation system for adding new books to the library archive.
                  </p>
                </li>

              </ul>
            </div>
          </div>
        </div>
        
        {/* Ski Area Management System */}
        <div className="services__content">
          <div>
            {/* <i className="uil uil-edit services__icon"></i> */}
            <i class="bi bi-geo services__icon"></i>
            
            <h3 className="services__title">
            Ski Area <br /> Management System
            </h3>
            <span>#java</span>
          </div>
          <span className="services__button" onClick={() => setToggleState(3)}>
            View More
            <i className="uil uil-arrow-right services__button-icon"></i>
          </span>
          <div
            className={
              toggleState === 3
                ? "services__modal active-modal"
                : "services__modal"
            }
          >
            <div className="services__modal-content">
              <i
                className="uil uil-times services__modal-close"
                onClick={() => setToggleState(0)}
              ></i>
              <h3 className="services__modal-title"> Ski Area Management System</h3>
              <p className="services__modal-description">
              Developed a Java-based system for managing ski lifts, runs, and parking at a ski resort.
              </p>

              <ul className="services__modal-services grid">
                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                  Applied OOP principles, design patterns, and exception handling for robustness and scalability.
                  </p>
                </li>

                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                  Implemented parking management with slot tracking and capacity-to-lift ratio validation.
                  </p>
                </li>

                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                  Developed ski run management with configurable difficulty levels and lift associations.
                  </p>
                </li>

                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                  Integrated file input to dynamically read and process lift and parking data.
                  </p>
                </li>

                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                  Created and linked lifts to predefined types, returning sorted lift collections.
                  </p>
                </li>
                
                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                  Implemented lift type management with unique identifiers, categories, and seat capacities.
                  </p>
                </li>
              
              </ul>
            </div>
          </div>
        </div>


        
      </div>
    </section>
  );
};

export default Services;
